import { get, orderBy } from "lodash";
import { useMemo, useState } from "react";

// a set of util hooks for common table scenarios

// soryBy format { key: 'something' , order: 'desc' }
// for sorting in object using dot notation as key like 'filter.name'
export function useSortBy({ defaultSort }) {
  const [sortBy, setSortBy] = useState(defaultSort);
  const onColumnSort = ({ key, order }) => {
    setSortBy({ key, order });
  }
  return { sortBy, onColumnSort }
}

export function useApplySort({ data, sortBy }) {
  const sortedData = useMemo(
    () => orderBy(data, [sortBy.key], [sortBy.order])
  , [data, sortBy]);
  return sortedData;
}

export function useTableSort({ defaultSort, data }) {
  const { sortBy, onColumnSort } = useSortBy({ defaultSort });
  const sortedData = useApplySort({ data, sortBy });
  return { sortBy, onColumnSort, sortedData };
}


export const defaultSearchFn = ({ searchText, data, columnKey }) => {
  const regex = new RegExp(searchText, 'i'); // ignore case
  return data.filter(row => regex.test(get(row, `${columnKey}`)));
}

export function useSearch({ data, columnKey, searchFn = defaultSearchFn }) {
  const [searchText, onSearch] = useState('');

  const filteredRows = useMemo(() => {
    if(searchText) {
      return searchFn({ searchText, data, columnKey });
    }
    return data
  }, [data, searchText, columnKey]);

  return { filteredRows, searchText, onSearch };
}
